import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const ConcreteCalculatorPage = () => {
  const [shape, setShape] = useState('slab');
  const [length, setLength] = useState('');
  const [width, setWidth] = useState('');
  const [depth, setDepth] = useState('');
  const [diameter, setDiameter] = useState('');
  const [result, setResult] = useState(null);

  const calculate = () => {
    let cubicFeet = 0;
    const d = parseFloat(depth) / 12; // Convert inches to feet

    if (shape === 'slab' && length && width && depth) {
      cubicFeet = parseFloat(length) * parseFloat(width) * d;
    } else if (shape === 'column' && diameter && depth) {
      const radius = parseFloat(diameter) / 2 / 12; // Convert inches to feet
      const height = parseFloat(depth); // Here depth is height in feet
      cubicFeet = Math.PI * radius * radius * height;
    }

    if (cubicFeet > 0) {
      const cubicYards = cubicFeet / 27;
      const bags40 = Math.ceil(cubicFeet / 0.30); // 40lb bag = ~0.30 cu ft
      const bags60 = Math.ceil(cubicFeet / 0.45); // 60lb bag = ~0.45 cu ft
      const bags80 = Math.ceil(cubicFeet / 0.60); // 80lb bag = ~0.60 cu ft

      setResult({ cubicFeet: cubicFeet.toFixed(2), cubicYards: cubicYards.toFixed(2), bags40, bags60, bags80 });
    }
  };

  return (
    <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
      <Header />
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-4 py-8">
          <nav className="text-sm text-gray-500 mb-4">
            <Link to="/home" className="text-cyan-400 hover:text-cyan-300">Home</Link>
            <span className="mx-2">›</span>
            <span className="text-gray-400">Concrete Calculator</span>
          </nav>
          <h1 className="text-3xl font-bold text-white mb-2">Concrete Calculator</h1>
          <p className="text-gray-400 mb-8">Calculate how much concrete you need for your project.</p>

          <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
            <div className="flex gap-4 mb-5">
              <button onClick={() => setShape('slab')} className={`px-4 py-2 rounded-lg font-medium ${shape === 'slab' ? 'bg-cyan-600 text-white' : 'bg-[#2a2a2a] text-gray-400'}`}>Slab/Square</button>
              <button onClick={() => setShape('column')} className={`px-4 py-2 rounded-lg font-medium ${shape === 'column' ? 'bg-cyan-600 text-white' : 'bg-[#2a2a2a] text-gray-400'}`}>Column/Cylinder</button>
            </div>
            {shape === 'slab' ? (
              <div className="grid md:grid-cols-3 gap-5">
                <div><label className="block text-gray-300 mb-2 font-medium">Length (ft)</label><Input type="number" value={length} onChange={(e) => setLength(e.target.value)} className="w-full bg-[#0d0d0d] border-[#2a2a2a] text-white" placeholder="10" /></div>
                <div><label className="block text-gray-300 mb-2 font-medium">Width (ft)</label><Input type="number" value={width} onChange={(e) => setWidth(e.target.value)} className="w-full bg-[#0d0d0d] border-[#2a2a2a] text-white" placeholder="10" /></div>
                <div><label className="block text-gray-300 mb-2 font-medium">Depth (inches)</label><Input type="number" value={depth} onChange={(e) => setDepth(e.target.value)} className="w-full bg-[#0d0d0d] border-[#2a2a2a] text-white" placeholder="4" /></div>
              </div>
            ) : (
              <div className="grid md:grid-cols-2 gap-5">
                <div><label className="block text-gray-300 mb-2 font-medium">Diameter (inches)</label><Input type="number" value={diameter} onChange={(e) => setDiameter(e.target.value)} className="w-full bg-[#0d0d0d] border-[#2a2a2a] text-white" placeholder="12" /></div>
                <div><label className="block text-gray-300 mb-2 font-medium">Height (ft)</label><Input type="number" value={depth} onChange={(e) => setDepth(e.target.value)} className="w-full bg-[#0d0d0d] border-[#2a2a2a] text-white" placeholder="3" /></div>
              </div>
            )}
            <Button onClick={calculate} className="mt-5 bg-cyan-600 hover:bg-cyan-500 text-white">Calculate</Button>
            {result && (
              <div className="mt-6 p-5 bg-[#0d0d0d] border border-[#2a2a2a] rounded-xl">
                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div className="p-4 bg-cyan-500/10 border border-cyan-500/30 rounded-lg text-center"><span className="text-gray-400 text-sm">Cubic Yards</span><p className="text-2xl font-bold text-cyan-400">{result.cubicYards}</p></div>
                  <div className="p-4 bg-[#1a1a1a] rounded-lg text-center"><span className="text-gray-500 text-sm">Cubic Feet</span><p className="text-2xl font-bold text-white">{result.cubicFeet}</p></div>
                </div>
                <h4 className="text-white font-medium mb-3">Pre-mixed Bags Needed:</h4>
                <div className="grid grid-cols-3 gap-3">
                  <div className="p-3 bg-[#1a1a1a] rounded-lg text-center"><span className="text-gray-500 text-sm">40 lb bags</span><p className="font-bold text-white">{result.bags40}</p></div>
                  <div className="p-3 bg-[#1a1a1a] rounded-lg text-center"><span className="text-gray-500 text-sm">60 lb bags</span><p className="font-bold text-white">{result.bags60}</p></div>
                  <div className="p-3 bg-[#1a1a1a] rounded-lg text-center"><span className="text-gray-500 text-sm">80 lb bags</span><p className="font-bold text-white">{result.bags80}</p></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ConcreteCalculatorPage;
